import { render, staticRenderFns } from "./InfoWorkHours.vue?vue&type=template&id=172e2136&scoped=true&"
import script from "./InfoWorkHours.vue?vue&type=script&lang=js&"
export * from "./InfoWorkHours.vue?vue&type=script&lang=js&"
import style0 from "./InfoWorkHours.vue?vue&type=style&index=0&id=172e2136&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e2136",
  null
  
)

export default component.exports